export default function PHP_dns_check_record() {
  return (
    <div>
      <h1>PHP_dns_check_record</h1>
    </div>
  );
}
